module.exports = __webpack_public_path__ + "fonts/SegmentRegular.woff2";